export class PsResourceCompany {

    _id; // number
    _description; // string
    _isContractor; // boolean

    constructor(
        id,
        description,
        isContractor,
    ) {
        this._id = id;
        this._description = description;
        this._isContractor = isContractor;
    }

    static null(contractor = false) {
        return new this(
            -1,
            '',
            contractor,
        );
    }

    static fromAPIContractor(contractor) {
        return new this(
            contractor.id,
            contractor.name,
            true,
        );
    }

    static fromAPICompany(company) {
        return new this(
            company.id,
            company.name,
            false,
        );
    }

    id() {
        return this._id;
    }

    description() {
        return this._description;
    }

    isContractor() {
        return this._isContractor;
    }

    isMyContractor(contractor) {
        return this.isContractor() && this.id() === contractor.id();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/resource/PsResourceCompany.js